import { Injectable } from '@angular/core';
import { Subscriber } from '../../lib/helpers/subscriber';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { isEmptyObject } from '../../lib/helpers/utils';
import { SaldoMovimiento, SaldoMovimientoHelper } from '../../models/b2b/saldoMovimiento';
import { SaldoDisponibleHelper } from '../../models/b2b/saldoDisponible';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

export interface SaldoModalData {
    open?: boolean;
    verBotonMovimientos?: boolean;
    saldoProximoCaducar?: boolean;
}

@Injectable()
export class SoledadSaldoService extends Subscriber {
    private addressCode: number = null;
    private codigoCliente: string = null;

    constructor(
        private api: ApiService,
        private store: Store<AppState>
    ) {
        super();
        this.addSubscription(
            this.store
                .select((state) => state.user.data)
                .subscribe((user) => {
                    if (user) {
                        this.addressCode = user.selectedAddressCode || null;
                        this.codigoCliente = user.clienteCodigo;
                    }
                })
        );
    }

    getSaldoTotal(selectedAddress: number = null): Observable<number> {
        const params = {
            CLIENTE: this.codigoCliente,
            DIRECCIONENVIO: selectedAddress || typeof selectedAddress === 'number' ? selectedAddress : this.addressCode
        };
        return this.api.callSoledad('b2bNew.dbo.HTML_PROMOSALDO_TOTAL', params).pipe(
            validateApiResponse('Error obteniendo saldo total' + '. Params: ' + JSON.stringify(params)),
            map((res: any) => {
                return typeof res[0].SALDO === 'number' ? parseFloat(res[0].SALDO.toFixed(2)) : 0;
            })
        );
    }

    getTotalesSaldosPorPromocion(selectedAddress: number = null) {
        const params = {
            CLIENTE: this.codigoCliente,
            DIRECCIONENVIO: selectedAddress || typeof selectedAddress === 'number' ? selectedAddress : this.addressCode
        };
        return this.api.callSoledad('b2bNew.dbo.HTML_PROMOSALDO_TOTALESPORPROMOCION', params).pipe(
            validateApiResponse('Error obteniendo saldos por promoción' + '. Params: ' + JSON.stringify(params)),
            map((res: any) => {
                return res.map((i: any) => SaldoDisponibleHelper.fromAPI(i));
            })
        );
    }

    getMovimientosSaldos(selectedAddress: number = null): Observable<SaldoMovimiento[]> {
        const params = {
            CLIENTE: this.codigoCliente,
            DIRECCIONENVIO: selectedAddress || typeof selectedAddress === 'number' ? selectedAddress : this.addressCode
        };
        return this.api.callSoledad('b2bNew.dbo.HTML_PROMOSALDO_MOVIMIENTOS', params).pipe(
            validateApiResponse('Error obteniendo movimientos de saldo' + '. Params: ' + JSON.stringify(params)),
            map((res: any) => {
                return res.reverse().map((i: any) => SaldoMovimientoHelper.fromAPI(i));
            })
        );
    }
}
